export const courses = [
    {
        name: "Claude Code in Action",
        provider: "Anthropic",
        icon: "simple-icons:anthropic",
        status: "in-progress", // "in-progress" | "completed"
        link: "https://anthropic.skilljar.com/",
    },
    {
        name: "Prompt Engineering",
        provider: "Anthropic",
        icon: "simple-icons:anthropic",
        status: "completed", // demo entry — edit or remove
        link: "https://anthropic.skilljar.com/",
    },
];
